import { db } from "../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";

const MAILUP_TOKEN_URL = "https://services.mailup.com/Authorization/OAuth/Token";
const MAILUP_API_BASE = "https://services.mailup.com/API/v1.1/Rest/ConsoleService.svc";

// Ottieni access token usando il refresh token salvato in Firestore
async function getAccessToken() {
  const snap = await getDoc(doc(db, "impostazioni", "mailup"));
  if (!snap.exists()) throw new Error("Configurazione MailUp non trovata");

  const { refreshToken, clientId, clientSecret } = snap.data();

  const response = await fetch(MAILUP_TOKEN_URL, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({
      grant_type: "refresh_token",
      client_id: clientId,
      client_secret: clientSecret,
      refresh_token: refreshToken,
    }),
  });

  const data = await response.json();

  if (!data.access_token) {
    throw new Error("Impossibile ottenere access token MailUp");
  }

  // Aggiorna il refresh token se ne è arrivato uno nuovo
  if (data.refresh_token && data.refresh_token !== refreshToken) {
    await updateDoc(doc(db, "impostazioni", "mailup"), {
      refreshToken: data.refresh_token,
    });
  }

  return data.access_token;
}

async function mailupGet(path) {
  const token = await getAccessToken();
  const response = await fetch(`${MAILUP_API_BASE}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.json();
}

// Recupera lista delle liste MailUp
export async function getListe() {
  try {
    const data = await mailupGet("/Console/List");
    return data.Items || [];
  } catch (error) {
    console.error("Errore recupero liste MailUp:", error);
    return [];
  }
}

// Recupera campagne di una lista
export async function getCampagne(listaId) {
  try {
    const data = await mailupGet(`/Console/List/${listaId}/Emails`);
    return data.Items || [];
  } catch (error) {
    console.error("Errore recupero campagne MailUp:", error);
    return [];
  }
}

export async function getGruppi(listaId) {
  try {
    const data = await mailupGet(`/Console/List/${listaId}/Groups`);
    return data.Items || [];
  } catch (error) {
    console.error("Errore recupero gruppi MailUp:", error);
    return [];
  }
}